export const unit = {
  state: {
    units: {}
  },
  mutations: {
    updateUnits: function(state, newList) {
      state.units = newList;
    }
  },
  getters: {
    getAllUnits(state) {
      return state.units;
    },
    getUnitsByType(state) {
      return function(unitType) {
        return state.units[unitType]
      }
    }
  }
}